import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import { MECHA_INFO } from './config';
import Store from './store';
const styles = require('./index.less');

const Page5 = ({ store }) => {
  store.use();
  const handleClick = e => {
    const id = e.target.getAttribute('data-mecha-id');
    if (!id) {
      return;
    }
    store.gounit(id);
  };

  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      <div className={styles.mechaUnitSwiper} onClick={handleClick}>
        {store.mechaList.length ? (
          <BaseSwiper store={store.mechaUnitSwiper}>
            {MECHA_INFO.map(item => {
              const { kv } = store.mechaList.find(i => i.mecha_id === item.id) || {};
              return (
                <div className={styles.slideItem} key={item.id}>
                  {React.createElement(item.component, { store, isActive: true, mechaId: item.id, kvImg: kv })}
                </div>
              );
            })}
          </BaseSwiper>
        ) : null}
        <div className={styles.indicator}>
          <div className={styles.prev} onClick={store.mechaUnitSwiper.goPrev} />
          <BaseSwiper store={store.indicatorSwiperStore}>
            {MECHA_INFO?.map((_, index) => (
              <div key={index} className={cx(styles.tabItem, index === store.activeIndex && styles.tabActive)} onClick={() => store.toSlideWithIndex(index)} />
            ))}
          </BaseSwiper>
          <div className={styles.next} onClick={store.mechaUnitSwiper.goNext} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(Page5, Store);
